import '../styles/index.css';
import '../styles/App.css';
import '../styles/Custom.css';
import '../styles/About.css';
import '../styles/CriticalAbout.css';
import '../styles/Navigation.css';
import '../styles/Projects.css';
import '../styles/Skills.css';
import '../styles/Socials.css';
import '../styles/Footer.css';
import '../styles/pages/PrivacyPolicy.css';
import '../styles/components/Box.css';
import '../styles/components/Skill.css';
import '../styles/components/Social.css';
import '../styles/components/Timer.css';
import '../styles/components/ProjectFilter.css';
import React from 'react';
import { I18nProvider } from '../contexts/I18nContext';

export default function App({ Component, pageProps }) {
    return (
        <I18nProvider>
            <Component {...pageProps} />
        </I18nProvider>
    );
}
